var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 1.69167V3.375C14.4917 3.825 17.0834 7.15 16.6334 10.8083C16.25 13.8417 13.8667 16.25 10.8334 16.6083V18.275C15.4167 17.8167 18.75 13.75 18.2917 9.16667C17.9167 5.20833 14.775 2.08333 10.8334 1.69167ZM9.16671 1.71667C7.54171 1.875 5.99171 2.5 4.72504 3.55L5.91671 4.78333C6.85004 4.03333 7.97504 3.55 9.16671 3.38333V1.71667ZM3.55004 4.725C2.50809 5.98945 1.86688 7.5359 1.70837 9.16667H3.37504C3.53337 7.98333 4.00004 6.85833 4.74171 5.91667L3.55004 4.725ZM1.71671 10.8333C1.88337 12.4667 2.52504 14.0083 3.55837 15.275L4.74171 14.0833C4.00582 13.1413 3.53667 12.0188 3.38337 10.8333H1.71671ZM5.91671 15.3083L4.72504 16.45C5.98736 17.5022 7.53277 18.1575 9.16671 18.3333V16.6667C7.98121 16.5134 6.85871 16.0442 5.91671 15.3083ZM10.4167 5.83333V10.2083L14.1667 12.4333L13.5417 13.4583L9.16671 10.8333V5.83333H10.4167Z",
    fill: "#F5F5F5",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGray);
export default __webpack_public_path__ + "static/media/clock-gray.310b0041deab2227baf1a1d043da835b.svg";
export { ForwardRef as ReactComponent };